import CryptoJS from 'crypto-js'

const key = '>.ePam2Dev~'

const encrypt = data => {
    try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), key)
    } catch (err) {
        console.log(err)
        return undefined
    }
}

const decrypt = cipher => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipher.toString(), key)
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    } catch (err) {
        console.log(err)
        return undefined
    }


}


export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined
        }
        return decrypt(serializedState)
        // return JSON.parse(serializedState)
    } catch (err) {
        return undefined
    }
}

export const saveState = (state) => {
    try {
        const serializedState = encrypt(state)
        // const serializedState = JSON.stringify(state)
        localStorage.setItem('state', serializedState)
    } catch (err) {
        /* ... */
        console.log(err)
    }
}




// WEBPACK FOOTER //
// ./src/storage/index.js